// extracted by mini-css-extract-plugin
export var backdrop = "Header-module--backdrop--tYQuP";
export var hamburger = "Header-module--hamburger--zF+l1";
export var header = "Header-module--header--utzDS";
export var isScrolled = "Header-module--isScrolled--AbrTE";
export var logo = "Header-module--logo--+MyHC";
export var toggled = "Header-module--toggled--6y6jV";